import Dependencies from '../utilities/dependencies';
import DependencyManager from '../utilities/dependency-manager';
import CmsApi from "../utilities/cms-api";
import Gallery from "../includes/gallery";

export default class InfoRow {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.info-row-element'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [Dependencies.libraries.glightbox];

	/** @type {HTMLElement} */
	#holderElement;

	/** @type {any} */
	#restaurant = null;

	static alpineData = null;

	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.#holderElement = holderElement;

		if (!document.querySelector('h1')) {
			let infoTitle = this.#holderElement.querySelector('.info-title');
			let infoContent = this.#holderElement.querySelector('.info-content');
			let h1 = document.createElement('h1');
			if (infoTitle) {
				h1.innerHTML = infoTitle.querySelector('h5').innerHTML;
				infoTitle.replaceChild(h1, infoTitle.querySelector('h5'));
			} else {
				h1.innerHTML = infoContent.querySelector('h2').innerHTML;
				infoContent.replaceChild(h1, infoContent.querySelector('h2'));
			}
		}

		if (this.#holderElement.querySelector('.restaurant-row')) {
			CmsApi.fetchRestaurants()
				.then(restaurants => {
					let self = this;
					this.#setRestaurant(restaurants);
					this.#holderElement.querySelector('.gallery-btn').addEventListener("click", function() {
						self.#openGalleryView();
					});
				});
		}
	}

	/**
	 * @param {Array<any>} restaurants
	 */
	#setRestaurant(restaurants) {
		const id = parseInt(this.#holderElement.querySelector('.restaurant-row').dataset.id.split('restaurant-')[1]);
		this.#restaurant = restaurants.find(r => r.id === id);
		console.log(this.#restaurant);
	}

	#openGalleryView() {
		let gallery = [];
		this.#restaurant.slides.forEach(slide => {
			gallery.push({
				'href': slide.image.lg,
				'type': 'image',
				'alt': slide.image.alt,
			});
		});
		const lightbox = GLightbox({
			elements: gallery,
			autoplayVideos: false,
		});
		lightbox.open();
	}
}
